"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ToggleUIButton_1 = __importDefault(require("../../molecules/ToggleUIButton"));
const ToolsHeader_1 = __importDefault(require("../../molecules/ToolsHeader"));
const model_interactions_1 = require("@completeanatomy/model-interactions");
const bridge_1 = require("@completeanatomy/bridge");
const GuidesProvider_1 = require("../../providers/GuidesProvider");
const ui_1 = require("@completeanatomy/ui");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const lodash_1 = require("lodash");
const hooks_1 = require("../../hooks");
const useHistoryOptions_1 = require("../../hooks/useHistoryOptions");
const Tools_1 = __importDefault(require("../../pages/Tools"));
const providers_1 = require("../../providers");
// eslint-disable-next-line max-lines-per-function
function ToolsModeTemplate({ title, clearTitle, doneTitle, children, onToggleUI = lodash_1.noop, onClear = lodash_1.noop, selectedType, isClearActive: isClearActiveProp, isGroupMode, selectedColor, selectedSize, setSelectedID, disableModelInteractions = false, isAddingLabels = false, setIsAddingLabels = lodash_1.noop, }) {
    const [, setSelectedType] = (0, react_1.useState)(selectedType || bridge_schema_1.ToolType.None);
    const bridge = (0, bridge_1.useBridge)();
    // const navigate = useNavigate();
    // const state = useLocation();
    const toolsService = (0, providers_1.useToolsService)();
    const labelToolManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const [isUIHidden, toggleUIHidden] = (0, ui_1.useToggleState)(false);
    const undoButtonRef = (0, react_1.useRef)(null);
    const { isClearActive } = (0, useHistoryOptions_1.useHistoryOptions)();
    const [{ isGuidesExpanded, isGuidesAvailable, guidesGridWidth }, setGuidesState,] = (0, GuidesProvider_1.useGuidesContext)();
    const { selectedLabelID, labels } = (0, hooks_1.useLabels)();
    const selectedLabel = labels && labels.length > 0
        ? labels.find(label => label && label.identifier === selectedLabelID)
        : null;
    const isCustomLabel = (selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.type) === bridge_schema_1.LabelType.Custom;
    const [trigger, setTrigger] = (0, react_1.useState)(0);
    const toggleUI = () => {
        if (isUIHidden) {
            // @ts-ignore
            window.CPBody[0].removeAttribute('toolkit-fullscreen');
        }
        else {
            // @ts-ignore
            window.CPBody[0].setAttribute('toolkit-fullscreen', '');
        }
        toggleUIHidden();
        onToggleUI();
        if (isGuidesAvailable) {
            setGuidesState(prev => (Object.assign(Object.assign({}, prev), { isGuidesVisible: isUIHidden })));
        }
    };
    const onClearHandler = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.toolkitHistoryAction({ type: bridge_schema_1.ToolType.ClearTool });
        onClear();
    };
    const onDone = () => {
        var _a;
        if (isGroupMode) {
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.deselectLabel();
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.resetGroupMode();
            localStorage.removeItem('groupModeID');
            labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.clearLastAddedLabel();
            bridge === null || bridge === void 0 ? void 0 : bridge.exitLabelGroupMode();
            return;
        }
        if (selectedType === bridge_schema_1.ToolType.Cut) {
            bridge === null || bridge === void 0 ? void 0 : bridge.toolSelect(bridge_schema_1.ToolType.None);
            bridge === null || bridge === void 0 ? void 0 : bridge.cutModelByLine({ action: bridge_schema_1.CutModelAction.Cancel });
        }
        if (selectedType === bridge_schema_1.ToolType.StickyHandWriting ||
            selectedType === bridge_schema_1.ToolType.StickyText) {
            setTrigger(prevTrigger => prevTrigger + 1);
            if (setSelectedID) {
                setSelectedID('');
            }
            toolsService === null || toolsService === void 0 ? void 0 : toolsService.getStickiesToolManager().selectSticky('');
            setSelectedType(bridge_schema_1.ToolType.None);
        }
        // const navigateBack = () => navigate('/');
        // const goBackAction = () => navigate(-1);
        //
        // const navigateAction =
        //   state.pathname === 'cross-sections' ? navigateBack : goBackAction;
        // hide ui before exit from tools
        if (selectedType === bridge_schema_1.ToolType.LabelsLeft ||
            selectedType === bridge_schema_1.ToolType.LabelsRight) {
            setTrigger(prevTrigger => prevTrigger + 1);
            bridge === null || bridge === void 0 ? void 0 : bridge.stickyUnselect();
            setSelectedType(bridge_schema_1.ToolType.None);
            if (isCustomLabel) {
                labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.clearLastAddedLabel();
                labelToolManager === null || labelToolManager === void 0 ? void 0 : labelToolManager.deselectLabel();
            }
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.performToolkitAction({
            type: bridge_schema_1.ToolType.None,
            currentOptions: {
                type: bridge_schema_1.ToolType.None,
            },
        });
        setIsAddingLabels(false);
        // @ts-ignore
        (_a = window === null || window === void 0 ? void 0 : window.toolkitPanelDelegate) === null || _a === void 0 ? void 0 : _a.deactivate();
        // navigateAction();
    };
    const onToggleUIHandler = (event) => {
        // prevent click outside on toggle ui button
        event.stopPropagation();
        toggleUI();
    };
    const onUndoRedoHandler = (event) => {
        event.stopPropagation();
    };
    const events = (0, ui_1.getPointersEvents)();
    (0, ui_1.useEvent)(undoButtonRef, events.down, onUndoRedoHandler);
    (0, react_1.useEffect)(() => {
        if (isGuidesAvailable) {
            setGuidesState(prev => (Object.assign(Object.assign({}, prev), { isGuidesVisible: true, isGuidesExpanded: true })));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const offset = isUIHidden || !isGuidesExpanded ? 0 : guidesGridWidth;
    const InteractionsLayer = disableModelInteractions
        ? 'div'
        : model_interactions_1.ModelInteractionsLayer;
    const shouldPerformAction = (type) => {
        return (type === ui_1.ActionType.SCALE ||
            type === ui_1.ActionType.PINCH ||
            type === ui_1.ActionType.ROTATE ||
            type === ui_1.ActionType.MOUSE_DOWN ||
            type === ui_1.ActionType.MOUSE_UP);
    };
    return ((0, jsx_runtime_1.jsxs)(InteractionsLayer, { shouldPerformAction: shouldPerformAction, "data-e2e": 'ToolsModeTemplate_InteractionsLayer', children: [!isUIHidden && (0, jsx_runtime_1.jsx)(StyledNavigationToolbar, { isToolsMode: true, isFullBody: true, "data-e2e": 'ToolsModeTemplate_StyledNavigationToolbar' }), (0, jsx_runtime_1.jsx)(Tools_1.default, { selectedToolType: selectedType, selectedColor: selectedColor, selectedSize: selectedSize, setSelectedId: setSelectedID, onDone: onDone, setSelectedType: setSelectedType, isAddingLabels: isAddingLabels, trigger: trigger, "data-e2e": 'ToolsModeTemplate_ToolsPage' }), children, (0, jsx_runtime_1.jsx)(ToolsHeader_1.default, { opened: !isUIHidden, clearTitle: isClearActive || isClearActiveProp ? clearTitle : undefined, isClearActive: isClearActive || isClearActiveProp, doneTitle: doneTitle, secondary: isGroupMode, onDone: onDone, onClear: onClearHandler, "data-e2e": 'ToolsModeTemplate_ToolsHeader', children: title }), (0, jsx_runtime_1.jsx)(StyledToggleUIButton, { hidden: isUIHidden, offset: offset, onClick: onToggleUIHandler, "data-e2e": 'ToolsModeTemplate_StyledToggleUIButton' })] }));
}
exports.default = (0, react_1.memo)(ToolsModeTemplate);
const StyledToggleUIButton = (0, styled_components_1.default)(ToggleUIButton_1.default) `
  position: absolute;
  right: 10px;
  bottom: 10px;

  transform: translateX(-${({ offset }) => offset}px);

  transition: transform 0.2s;
`;
const StyledNavigationToolbar = (0, styled_components_1.default)(model_interactions_1.NavigationToolbar) `
  position: absolute;
  z-index: 1;
  margin-top: 46px;

  width: unset;
`;
